window.isRecaptchaCustomInited = window.isRecaptchaCustomInited ?? false;

export function initRecaptcha() {
  if (!window.isRecaptchaCustomInited) {
    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://www.google.com/recaptcha/api.js";
    script.onload = () => {
      window.isRecaptchaCustomInited = window.grecaptcha ?? true;
      window.grecaptcha.ready(() => {
        window.isRecaptchaCustomInited = true;
      });
    };
    head.appendChild(script);
    window.isRecaptchaCustomInited = true;
  } else {
    return false;
  }
  return true;
}
